import { render } from "./IconCardGiftcard.vue?vue&type=template&id=fcf3c91a"
import script from "./IconCardGiftcard.vue?vue&type=script&lang=js"
export * from "./IconCardGiftcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__